import { Children, ComponentType } from 'react';
import { ButtonText } from './_/ButtonText';
import { ButtonVariantProps, useDefaultButtonVariant } from './_/ButtonVariant';

export {
  ButtonText,
  ButtonTextStyleConsumer,
  ButtonTextStyleProvider,
  useButtonTextStyle,
} from './_/ButtonText';
export type { ButtonTextStyle } from './_/ButtonText';
export { DefaultButtonVariantProvider } from './_/ButtonVariant';
export type { ButtonVariantProps } from './_/ButtonVariant';

export interface ButtonProps extends ButtonVariantProps {
  Variant?: ComponentType<ButtonVariantProps>;
}

export function Button(props: ButtonProps): JSX.Element {
  const DefaultButtonVariant = useDefaultButtonVariant();
  const { Variant = DefaultButtonVariant, ...restProps } = props;

  const children = Children.toArray(props.children).map((child, idx) => {
    if (typeof child === 'string') {
      return <ButtonText key={`text-${idx}`}>{child}</ButtonText>;
    } else {
      return child;
    }
  });

  return <Variant {...restProps}>{children}</Variant>;
}

export namespace Button {
  export const Text = ButtonText;
}
